import { render, staticRenderFns } from "./asset_return_apply_detail.vue?vue&type=template&id=541264e6&scoped=true"
import script from "./asset_return_apply_detail.vue?vue&type=script&lang=js"
export * from "./asset_return_apply_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541264e6",
  null
  
)

export default component.exports